/* globals grecaptcha */
/* globals serialize */
/* globals modal */

/**
 * {{name}}
 * Plugins JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  {{author}}
 * @preserve
 */

/*
 * Table of Contents
 *
{{toc}}
 */

/*
--------------------
Global
--------------------
*/

// Fallback for inadvertant console statements
if (!window.console) {
    window.console = {
        log:   function(){},
        warn:  function(){},
        error: function(){}
    };
}

/*eslint no-unused-vars: 0*/
// Source: http://davidwalsh.name/javascript-debounce-function
function debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}

/*
--------------------
Modules
--------------------
*/


// Bind Events to multi elements
function bindEventMulti(el,fn,e){
    for (var i = 0; i < el.length; i+=1) {
        el[i].addEventListener(e, fn);
    }
}

// Insert node after referenced node
function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

// Image "object-fit: cover" fallback
var objectFit = function (selector, settings) {

    var objectFitSupprt = 'objectFit' in document.documentElement.style === false ? false : true;

    if ($(selector).length && !objectFitSupprt) {

        var $this = $(selector),
            objs = [],
            settings = {
                display:      undefined === settings.display ? 'block' : settings.display,
                position:     undefined === settings.position ? 'center center' : settings.position,
                adjustHeight: undefined === settings.adjustHeight ? false : settings.adjustHeight
            };

        // Init
        objs = $this.toArray().map(function (el, i) {

            // adjust height if required
            if (settings.adjustHeight) {
                $(el).parent().css('height', '');
                $(el).parent().css('height', $(el).height());
            }

            // set the bg image
            $(el).css('opacity', 0);
            $(el).parent().css({
                'background-image':    'url(' + $(el).attr('src') + ')',
                'background-size':     'cover',
                'background-position': settings.position,
                'display':             settings.display
            });

        });

    }

};
